import { createSelector } from 'reselect';

import {
  selectEntitiesMissions,
  selectEntitiesMissionsEntityReward,
} from '../../../selectors/entities/missions/entitiesMissionsPrimary.selector';
import { type Selector } from '../../../types/selectors';
import { createResultEqualSelector } from '../../../utils/reselect';
import { type MissionState } from '../types/state/missions';
import { MissionRewardTypes } from '../types/state/missions';

// #region Complexes
export const selectMissionIds: Selector<Array<number>> = createResultEqualSelector(
  [selectEntitiesMissions],
  (missions) => Object.keys(missions).map((key) => parseInt(key, 10)),
);

export const selectMissionFreebetsRewardAmount: Selector<number> = createSelector(
  [selectEntitiesMissionsEntityReward],
  (reward) =>
    reward?.rewardType === MissionRewardTypes.FREEBETS && reward?.rewardParams?.amount ? reward.rewardParams.amount : 0,
);

export const selectMissionFreebetsRewardDisplayValue: Selector<number | undefined> = createSelector(
  [selectEntitiesMissionsEntityReward],
  (reward) => reward?.rewardParams?.displayValue,
);

export const selectMissionsArray: Selector<Array<MissionState>> = createResultEqualSelector(
  [selectMissionIds, selectEntitiesMissions],
  (missionIds, missionsState) => missionIds.map((missionId) => missionsState[missionId]).filter((k) => k),
);

export const selectActiveMissions: Selector<Array<number>> = createResultEqualSelector(
  [selectMissionsArray],
  (missions) =>
    missions
      .filter(
        (mission) => Date.now() >= (mission.startDate ?? Infinity) && Date.now() <= (mission.endDate ?? -Infinity),
      )
      .map((mission) => mission.missionId),
);
// #endregion
